// extracted by mini-css-extract-plugin
module.exports = {"TrustedIcons":"TrustedIcons___1kzVe","NormalFooter":"NormalFooter___2CXH5","loading":"loading___cpiSw"};